import React, { memo } from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface SelectBoxProps {
  options: { value: string | number; label: React.ReactNode; color?: string }[]; // Options for the Select box
  placeholder?: string; // Placeholder text
  onChange?: (value: string | number | any) => void; // Callback when the selected value changes
  allowClear?: boolean; // Whether to show the clear button
  mode?: 'multiple' | 'tags'; // Mode for the Select box (default, multiple, tags)
  value?: string | number | (string | number) | null | any; // Selected value
  defaultValue?: string | number | (string | number) | null | any; // Default selected value
  disabled?: boolean; // Disable the Select box
  style?: React.CSSProperties; // Custom styles for the Select box
  loading?: boolean; // Show loading spinner
  showSearch?: boolean; // Show search input
  maxTagCount?: number; // Max number of tags to show
  maxTagTextLength?: number; // Max length of tag text
  width?: number; // Width of the Select box
  height?: number; // Height of the Select box
  onSearch?: (value: string) => void;
}

type IOption = {
  value: string | number; // Value of the option
  label: React.ReactNode; // Label of the option
  color?: string; // Optional color for the option
};

const SelectBox: React.FC<SelectBoxProps> = ({
  options,
  placeholder = 'Select',
  onChange,
  allowClear = false,
  mode,
  defaultValue,
  value,
  disabled = false,
  style,
  loading = false,
  showSearch = false,
  maxTagCount,
  maxTagTextLength,
  width,
  height,
  onSearch,
}) => {
  return (
    <Select
      placeholder={placeholder}
      onChange={onChange}
      allowClear={allowClear}
      mode={mode}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
      style={{ ...style, width: width, height: height }}
      loading={loading}
      showSearch={showSearch}
      popupMatchSelectWidth={false}
      maxTagCount={maxTagCount}
      maxTagTextLength={maxTagTextLength}
      maxTagPlaceholder={values => `+ ${values.length - 0} more`}
      onSearch={onSearch}
    >
      {options.map((option: IOption) => (
        <Option key={option.value} value={option.value}>
          <div
            style={{
              paddingTop: '12px',
              paddingBottom: '12px',
              backgroundColor: option.color || 'transparent',
              color: option.color ? '#fff' : 'inherit',
              borderRadius: option.color ? '4px' : '0',
              paddingLeft: '8px',
            }}
          >
            <span className="capitalize">{option.label}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default memo(SelectBox);
